import React, { useState } from "react";
import { inject, observer } from "mobx-react";
import bars from "../../Assets/bars.svg";
import { Drawer, Avatar, message } from "antd";
import { useHistory } from "react-router-dom";
import { Colors, HexColors } from "../../Utils/colors";
import { UserOutlined } from "@ant-design/icons";
import { Popconfirm } from "antd";
import { QuestionCircleOutlined } from "@ant-design/icons";

const Header = inject("store")(
  observer(({ store, user }) => {
    const history = useHistory();
    const [visible, setVisible] = useState(false);
    const patient = user;

    const showDrawer = () => {
      setVisible(!visible);
    };
    const onClose = () => {
      setVisible(false);
    };

    function confirm(e) {
      console.log(e);
      history.push("/login");
      localStorage.clear();
      // message.success('Click on Yes');
    }

    function cancel(e) {
      console.log(e);
      // message.error('Click on No');
    }

    console.log("header", patient);

    return (
      <div
        className=" pt-4 mt-4 pl-6 pr-4 flex justify-between h-12 p-2"
        style={{ alignItems: "center" }}
      >
        <div className="flex " style={{ alignItems: "center" }}>
          <div
            type="primary"
            onClick={showDrawer}
            style={{ marginRight: "10px" }}
            className="flex cursor-pointer"
          >
            <img src={bars} alt="" />
            <div
              className="ant-dropdown-link pl-4"
              onClick={(e) => e.preventDefault()}
            >
              {store.color === Colors.allopathic
                ? "Allopathic"
                : store.color === Colors.homeopathic
                ? "Homeopathic"
                : "Ayurvedic"}
            </div>
          </div>
          <Drawer
            placement="left"
            width="271px"
            closable={false}
            onClose={onClose}
            visible={visible}
            maskStyle={{
              background: "rgba(255, 255, 255, 0.7)",
              backdropFilter: "blur(1px)",
            }}
          >
            <div>
              <div
                style={{
                  background: "#FFFFFF",
                  width: "300px",
                  boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.02)",
                  border: "1px solid #FAF2F2",
                }}
                className="-mt-6 -ml-6 h-32 p-4 pt-8 pl-7"
              >
                <svg
                  width="199"
                  height="59"
                  viewBox="0 0 199 59"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M84.7496 25.1254H80.1917L79.4163 27.3482H77.5439L81.4399 16.498H83.5013L87.3973 27.3482H85.525L84.7496 25.1254ZM84.2389 23.675L82.4801 18.6455L80.6834 23.675H84.2389Z"
                    fill="#2892AF"
                  />
                  <path
                    d="M100.353 25.1254H95.7952L95.0198 27.3482H93.1475L97.0434 16.498H99.1049L103.001 27.3482H101.128L100.353 25.1254ZM99.8614 23.675L98.0836 18.6455L96.3058 23.675H99.8614Z"
                    fill="#2892AF"
                  />
                  <path
                    d="M115.048 27.3482L112.551 23.0157H111.189V27.3482H109.412V16.498H113.175C114.007 16.498 114.726 16.6487 115.293 16.9313C115.88 17.2139 116.315 17.6094 116.598 18.0992C116.882 18.589 117.033 19.1352 117.033 19.738C117.033 20.4538 116.825 21.0943 116.409 21.6594C115.993 22.2434 115.369 22.6201 114.499 22.8461L117.185 27.3294H115.048V27.3482ZM111.189 21.5841H113.156C113.818 21.5841 114.329 21.4145 114.669 21.0755C115.01 20.7364 115.18 20.3031 115.18 19.738C115.18 19.1729 115.01 18.7397 114.669 18.4194C114.329 18.0992 113.837 17.9485 113.156 17.9485H111.189V21.5841Z"
                    fill="#2892AF"
                  />
                  <path
                    d="M126.167 26.7454C125.316 26.2745 124.635 25.6152 124.144 24.7676C123.652 23.9199 123.406 22.9592 123.406 21.9043C123.406 20.8494 123.652 19.8887 124.144 19.0411C124.635 18.1934 125.316 17.5341 126.167 17.0632C127.018 16.6111 127.945 16.3662 128.966 16.3662C129.988 16.3662 130.933 16.6111 131.784 17.082C132.635 17.5529 133.297 18.2122 133.789 19.0599C134.281 19.9076 134.526 20.8494 134.526 21.9232C134.526 22.9969 134.281 23.9199 133.789 24.7676C133.297 25.6152 132.635 26.2745 131.784 26.7454C130.933 27.2164 130.006 27.4613 128.966 27.4613C127.945 27.4613 127.018 27.2164 126.167 26.7454ZM130.876 25.4268C131.444 25.1066 131.879 24.6357 132.2 24.0141C132.522 23.4113 132.673 22.6955 132.673 21.9043C132.673 21.1132 132.522 20.3973 132.2 19.7946C131.879 19.1918 131.444 18.7208 130.876 18.4006C130.309 18.0804 129.666 17.9109 128.947 17.9109C128.229 17.9109 127.586 18.0804 127.018 18.4006C126.451 18.7208 126.016 19.1918 125.694 19.7946C125.373 20.3973 125.222 21.0943 125.222 21.9043C125.222 22.7143 125.373 23.4113 125.694 24.0141C126.016 24.6169 126.451 25.0878 127.018 25.4268C127.586 25.7471 128.229 25.9166 128.947 25.9166C129.666 25.9166 130.328 25.7471 130.876 25.4268Z"
                    fill="#2892AF"
                  />
                  <path
                    d="M148.843 19.625C148.559 19.0788 148.162 18.6832 147.67 18.4006C147.16 18.1181 146.592 17.9862 145.93 17.9862C145.212 17.9862 144.569 18.1557 144.001 18.476C143.434 18.7962 142.999 19.2483 142.677 19.8511C142.356 20.4539 142.205 21.132 142.205 21.9043C142.205 22.6766 142.356 23.3736 142.677 23.9764C142.999 24.5792 143.434 25.0313 144.001 25.3515C144.569 25.6717 145.212 25.8413 145.93 25.8413C146.895 25.8413 147.689 25.5775 148.294 25.0313C148.899 24.485 149.278 23.7503 149.41 22.8273H145.325V21.3957H151.32V22.7897C151.207 23.6373 150.904 24.4096 150.412 25.1066C149.921 25.8224 149.297 26.3687 148.521 26.802C147.746 27.2352 146.876 27.4424 145.93 27.4424C144.909 27.4424 143.982 27.1975 143.131 26.7266C142.28 26.2557 141.618 25.5964 141.126 24.7487C140.635 23.901 140.389 22.9592 140.389 21.8855C140.389 20.8118 140.635 19.8699 141.126 19.0222C141.618 18.1746 142.299 17.5153 143.15 17.0443C143.982 16.6111 144.928 16.3662 145.93 16.3662C147.084 16.3662 148.124 16.6488 149.013 17.2139C149.921 17.779 150.564 18.589 150.98 19.625H148.843Z"
                    fill="#2892AF"
                  />
                  <path
                    d="M165.826 16.498L162.233 23.4113V27.3482H160.455V23.4113L156.843 16.498H158.829L161.344 21.8101L163.86 16.498H165.826Z"
                    fill="#2892AF"
                  />
                  <path
                    d="M178.498 25.1254H173.94L173.165 27.3482H171.293L175.189 16.498H177.25L181.146 27.3482H179.274L178.498 25.1254ZM177.988 23.675L176.21 18.6455L174.432 23.675H177.988Z"
                    fill="#2892AF"
                  />
                  <path
                    d="M198.999 16.498V27.3294H197.221V19.9264L193.912 27.3482H192.682L189.354 19.9264V27.3482H187.576V16.498H189.505L193.325 24.9936L197.127 16.498H198.999Z"
                    fill="#2892AF"
                  />
                  <path
                    d="M97.6667 43.9291C97.0426 43.24 96.74 42.3212 96.74 41.211C96.74 40.1007 97.0426 39.1819 97.6667 38.4928C98.2908 37.7654 99.0473 37.4209 99.9929 37.4209C100.73 37.4209 101.355 37.6315 101.846 38.0334C102.338 38.4354 102.66 38.9905 102.811 39.6796H101.884C101.563 38.7417 100.92 38.2631 99.9929 38.2631C99.2932 38.2631 98.7447 38.5311 98.3097 39.0671C97.8936 39.6031 97.6667 40.3113 97.6667 41.1918C97.6667 42.0532 97.8747 42.7614 98.3097 43.2974C98.7258 43.8525 99.2932 44.1205 99.9929 44.1205C100.939 44.1205 101.563 43.642 101.884 42.704H102.811C102.66 43.4123 102.338 43.9482 101.846 44.3693C101.355 44.7905 100.73 44.9819 99.9929 44.9819C99.0473 44.9627 98.2908 44.6182 97.6667 43.9291Z"
                    fill="#00A504"
                  />
                  <path
                    d="M115.18 38.4734C115.785 39.1817 116.107 40.0814 116.107 41.1916C116.107 42.3018 115.804 43.2015 115.18 43.9097C114.556 44.6179 113.781 44.9625 112.816 44.9625C111.87 44.9625 111.076 44.6179 110.471 43.9097C109.866 43.2015 109.544 42.3018 109.544 41.1916C109.544 40.0814 109.847 39.1817 110.471 38.4734C111.076 37.7652 111.87 37.4207 112.816 37.4207C113.781 37.4207 114.556 37.7652 115.18 38.4734ZM114.518 43.2972C114.953 42.7612 115.161 42.053 115.161 41.1916C115.161 40.3302 114.953 39.622 114.518 39.086C114.083 38.55 113.516 38.2629 112.816 38.2629C112.116 38.2629 111.568 38.5309 111.133 39.086C110.698 39.6411 110.49 40.3302 110.49 41.1916C110.49 42.053 110.698 42.7612 111.133 43.2972C111.568 43.8331 112.135 44.1203 112.816 44.1203C113.516 44.1203 114.083 43.8523 114.518 43.2972Z"
                    fill="#00A504"
                  />
                  <path
                    d="M128.91 37.5354V44.8667H128.229L124.182 39.0476V44.8667H123.293V37.5354H124.182L128.04 43.1056V37.5354H128.91Z"
                    fill="#00A504"
                  />
                  <path
                    d="M142.149 37.5354V44.8667H141.469L137.421 39.0476V44.8667H136.532V37.5354H137.421L141.279 43.1056V37.5354H142.149Z"
                    fill="#00A504"
                  />
                  <path
                    d="M149.771 37.5354H154.385V38.3776H150.697V40.6746H154.045V41.5169H150.697V44.0053H154.385V44.8475H149.771V37.5354Z"
                    fill="#00A504"
                  />
                  <path
                    d="M162.234 43.9288C161.61 43.2397 161.307 42.3209 161.307 41.2107C161.307 40.1005 161.61 39.1817 162.234 38.4926C162.858 37.7652 163.615 37.4207 164.56 37.4207C165.298 37.4207 165.922 37.6312 166.414 38.0332C166.905 38.4352 167.227 38.9903 167.378 39.6794H166.452C166.13 38.7414 165.487 38.2629 164.56 38.2629C163.861 38.2629 163.312 38.5309 162.877 39.0668C162.461 39.6028 162.234 40.3111 162.234 41.1916C162.234 42.053 162.442 42.7612 162.877 43.2972C163.293 43.8331 163.861 44.1011 164.56 44.1011C165.506 44.1011 166.13 43.6226 166.452 42.6846H167.378C167.227 43.3929 166.905 43.9288 166.414 44.35C165.922 44.7711 165.298 44.9625 164.56 44.9625C163.615 44.9625 162.858 44.6179 162.234 43.9288Z"
                    fill="#00A504"
                  />
                  <path
                    d="M173.827 38.3585V37.5354H179.803V38.3776H177.288V44.8667H176.361V38.3585H173.827Z"
                    fill="#00A504"
                  />
                  <path
                    d="M77.5439 41.3635H90.0261"
                    stroke="#00A504"
                    stroke-width="2"
                    stroke-miterlimit="10"
                  />
                  <path
                    d="M185.685 41.3635H198.999"
                    stroke="#00A504"
                    stroke-width="2"
                    stroke-miterlimit="10"
                  />
                  <path
                    d="M35.1652 2.97064C33.6326 1.43806 31.5074 0.483398 29.1555 0.483398C24.4664 0.483398 20.655 4.29107 20.655 8.98391V29.6426H23.369C22.7765 28.4905 22.2827 27.2871 21.8913 26.0361C21.4926 24.7596 21.2256 23.4355 21.0793 22.0968C21.072 21.9724 21.0647 21.8481 21.0574 21.7237C21.0501 21.6432 21.0464 21.5664 21.0427 21.486C21.0098 21.0214 20.9769 20.5532 20.9732 20.0887L21.0025 19.0865C21.0098 18.75 21.0171 18.4135 21.0647 18.0843C21.3171 15.4178 22.0376 12.8026 23.1971 10.4214C23.7531 9.21435 24.4371 8.08046 25.1796 6.99046C25.9258 5.90412 26.7451 4.87265 27.6742 3.91433L28.5447 3.01453L29.3677 3.8997C30.1724 4.77389 30.8747 5.70295 31.5148 6.6759C32.1549 7.64519 32.7255 8.66203 33.201 9.72277C33.6984 10.7725 34.0678 11.8808 34.3861 12.9928C34.4995 13.4756 34.6055 13.9621 34.697 14.4485C33.1937 8.29992 28.9434 4.07893 28.6874 3.83386C23.8702 8.83395 21.5182 15.3995 22.4327 21.486C22.4436 21.5664 22.4546 21.6469 22.4729 21.7237C22.5863 22.4516 22.7546 23.1685 22.9667 23.8781C23.6873 26.2666 24.8468 28.1796 26.0136 29.6426H37.6561V8.98391C37.6561 6.64298 36.7014 4.51785 35.1652 2.97064Z"
                    fill="url(#paint0_radial)"
                  />
                  <path
                    d="M49.8111 21.7236C48.3846 21.7492 43.3003 21.976 37.6602 24.5657V21.7236H49.8111Z"
                    fill="url(#paint1_linear)"
                  />
                  <path
                    d="M32.956 38.7209H20.5674C20.5966 38.7026 20.6259 38.6843 20.6552 38.666C20.8161 38.56 20.977 38.4502 21.1343 38.3405C22.6523 37.2688 23.98 35.9374 24.942 34.3865C25.1029 34.1305 25.2529 33.8671 25.3919 33.5964C24.3568 34.2512 23.3472 34.8657 22.3341 35.4143C22.4474 35.3339 22.5608 35.2497 22.6706 35.1656C22.9156 34.9864 23.1607 34.7962 23.4241 34.595C23.5265 34.5109 23.6325 34.4267 23.7423 34.3426C23.8996 34.2183 24.0678 34.0866 24.2397 33.9512C24.3458 33.8635 24.4592 33.7757 24.5726 33.6842C24.6896 33.5891 24.8176 33.4904 24.9457 33.388C25.1029 33.2599 25.2675 33.1283 25.4431 32.9929C25.4687 33.0258 25.4907 33.0588 25.5163 33.0917C25.6333 33.2526 25.7577 33.4099 25.8857 33.5672C25.9662 33.6733 26.0539 33.7793 26.1381 33.8817C26.3466 34.1305 26.566 34.3792 26.7928 34.6279C27.2464 35.1254 27.7365 35.6009 28.2522 36.0398C29.291 36.9396 30.4871 37.6419 31.6905 38.1978C32.1075 38.388 32.5317 38.5636 32.956 38.7209Z"
                    fill="url(#paint2_radial)"
                  />
                  <path
                    d="M58.3107 30.2241C58.3107 32.5687 57.3597 34.6975 55.8234 36.2338C54.2799 37.77 52.1584 38.721 49.8102 38.721H40.2489C39.9965 38.6771 39.7442 38.6296 39.4954 38.5784C38.8773 38.4503 38.2628 38.304 37.6556 38.1431C35.8963 37.6822 34.1918 37.086 32.6299 36.2777C31.5802 35.7217 30.6218 35.0852 29.7842 34.3061C29.3599 33.9111 28.9612 33.4941 28.5845 33.0479C28.3943 32.8248 28.2114 32.5907 28.0212 32.3529C27.842 32.1225 27.6664 31.8884 27.4982 31.647C27.4579 31.5921 27.4213 31.5373 27.3848 31.4824C27.4433 31.4385 27.4982 31.3946 27.5567 31.3544C27.6518 31.2812 27.7432 31.2081 27.842 31.1349C27.8493 31.1313 27.853 31.1239 27.8603 31.1203C28.5699 30.5826 29.2173 30.0925 29.8098 29.6426C30.1719 29.3719 30.5084 29.1195 30.8303 28.8781C30.8303 28.8781 30.8303 28.8781 30.834 28.8745C30.8706 28.8488 30.9071 28.8196 30.9401 28.794L30.9437 28.7903C30.9474 28.7903 30.951 28.7867 30.951 28.7867C31.624 28.2819 32.2129 27.8466 32.747 27.4662C33.7784 26.7274 34.5904 26.186 35.3476 25.7544C35.7536 25.5203 36.1633 25.3009 36.5656 25.096C36.7668 24.9936 36.968 24.8949 37.1691 24.7961C37.3301 24.7193 37.4947 24.6425 37.6556 24.5693V24.5657C37.8312 24.4852 38.0067 24.4047 38.1823 24.3316C38.3067 24.2767 38.431 24.2218 38.5517 24.1743C38.5627 24.1706 38.5774 24.1633 38.5883 24.1597C38.7127 24.1048 38.837 24.0536 38.9578 24.006C39.1333 23.9329 39.3089 23.867 39.4808 23.8012C39.7807 23.6842 40.0734 23.5781 40.366 23.4757C40.9988 23.2526 41.6206 23.0624 42.2168 22.8941C42.3741 22.8502 42.5313 22.8063 42.6886 22.7661C42.824 22.7295 42.9593 22.6929 43.091 22.66C43.2775 22.6125 43.4641 22.5686 43.6433 22.5283C43.7896 22.4954 43.9359 22.4588 44.0749 22.4296C44.3565 22.3674 44.6345 22.3125 44.9015 22.2613C45.0405 22.2321 45.1759 22.2065 45.3112 22.1845C45.783 22.1004 46.2329 22.0309 46.6499 21.976C46.7852 21.9577 46.9169 21.9394 47.0449 21.9248C47.5607 21.8626 48.0252 21.8187 48.4312 21.7895C48.6324 21.7748 48.8189 21.7639 48.9908 21.7529C49.075 21.7492 49.1554 21.7456 49.2323 21.7419C49.4627 21.7309 49.6565 21.7273 49.8102 21.7236C54.5067 21.7236 58.3107 25.5313 58.3107 30.2241Z"
                    fill="url(#paint3_radial)"
                  />
                  <path
                    d="M25.443 32.993C25.2674 33.1284 25.1028 33.26 24.9456 33.3881C24.8175 33.4905 24.6895 33.5892 24.5725 33.6843C24.4591 33.7758 24.3457 33.8636 24.2396 33.9514C24.0677 34.0867 23.8995 34.2184 23.7422 34.3427C23.6325 34.4269 23.5264 34.511 23.424 34.5951C23.1606 34.7963 22.9155 34.9865 22.6705 35.1657C22.5607 35.2498 22.4474 35.334 22.334 35.4144C22.3303 35.4218 22.323 35.4217 22.3157 35.4254C21.5805 35.8278 20.8416 36.1972 20.0918 36.53C18.3105 37.3311 16.4926 37.92 14.6199 38.3004C14.1517 38.4028 13.6762 38.4832 13.197 38.5564C12.8093 38.6222 12.4216 38.6735 12.0265 38.721H8.50417C3.80767 38.721 0 34.9133 0 30.2241C0 25.5313 3.80767 21.7236 8.50417 21.7236H21.0574C21.0647 21.848 21.0721 21.9724 21.0794 22.0967C21.2257 23.4354 21.4927 24.7595 21.8914 26.0361C22.2828 27.287 22.7765 28.4904 23.3691 29.6426C23.9653 30.8167 24.6603 31.9323 25.443 32.993Z"
                    fill="url(#paint4_linear)"
                  />
                  <path
                    d="M37.656 21.7236V24.5657C37.4951 24.6388 37.3342 24.7156 37.1696 24.7961C36.9721 24.8912 36.7672 24.9936 36.566 25.096C36.1637 25.3009 35.754 25.5203 35.348 25.7544C34.5909 26.186 33.7789 26.7274 32.7474 27.4662C32.2134 27.8466 31.6245 28.2819 30.9515 28.7867C30.9515 28.7867 30.9478 28.7903 30.9442 28.7903L30.9405 28.794C30.9076 28.8196 30.871 28.8488 30.8344 28.8745C30.8308 28.8781 30.8308 28.8781 30.8308 28.8781C30.5089 29.1195 30.1724 29.3719 29.8103 29.6426C29.2177 30.0925 28.5703 30.5826 27.8607 31.1203C27.8534 31.1239 27.8497 31.1313 27.8424 31.1349C27.7437 31.2081 27.6522 31.2812 27.5571 31.3544C27.4986 31.3946 27.4437 31.4385 27.3852 31.4824C27.1694 31.1751 26.9646 30.8606 26.7707 30.5387C26.7707 30.535 26.7671 30.5314 26.7671 30.5314C26.5183 30.2571 26.2659 29.9608 26.0136 29.6426C24.8468 28.1795 23.6873 26.2665 22.9667 23.878C22.7545 23.1684 22.5863 22.4515 22.4729 21.7236H37.656Z"
                    fill="url(#paint5_linear)"
                  />
                  <path
                    d="M21.0574 21.7238H20.655V21.4861H21.0427C21.0464 21.5666 21.0501 21.6434 21.0574 21.7238Z"
                    fill="url(#paint6_linear)"
                  />
                  <path
                    d="M37.6565 21.4861V21.7238H22.4733C22.4551 21.647 22.4441 21.5666 22.4331 21.4861H37.6565Z"
                    fill="url(#paint7_linear)"
                  />
                  <path
                    d="M20.794 36.4165C20.7501 36.4458 20.7026 36.4714 20.655 36.5006V36.497C20.7026 36.4677 20.7501 36.4421 20.794 36.4165Z"
                    fill="url(#paint8_linear)"
                  />
                  <path
                    d="M21.4114 36.0361C21.2359 36.1495 21.0567 36.2593 20.8628 36.3726C21.0567 36.2556 21.2395 36.1459 21.4114 36.0361Z"
                    fill="url(#paint9_linear)"
                  />
                  <path
                    d="M37.6561 39.9645V50.3012C37.6561 51.3583 37.4622 52.3751 37.1074 53.3078C37.0416 53.4761 36.9721 53.6443 36.8989 53.8089C36.7855 54.0577 36.6612 54.2991 36.5295 54.5332C36.4271 54.7087 36.321 54.8843 36.2039 55.0526C34.675 57.313 32.0854 58.8017 29.1555 58.8017C26.8036 58.8017 24.6858 57.8434 23.1496 56.3108C21.6133 54.7673 20.655 52.6385 20.655 50.3012V38.666C20.816 38.56 20.9769 38.4502 21.1342 38.3405C22.6521 37.2688 23.9799 35.9374 24.9419 34.3865C25.1028 34.1305 25.2528 33.8671 25.3918 33.5964C24.3566 34.2512 23.3471 34.8657 22.3339 35.4143C22.4473 35.3339 22.5607 35.2497 22.6704 35.1656C22.9155 34.9864 23.1606 34.7962 23.4239 34.595C23.5263 34.5109 23.6324 34.4267 23.7421 34.3426C23.8994 34.2183 24.0677 34.0866 24.2396 33.9512C24.3457 33.8635 24.459 33.7757 24.5724 33.6842C24.6895 33.5891 24.8175 33.4904 24.9455 33.388C25.1028 33.2599 25.2674 33.1283 25.443 32.9929C25.4686 33.0258 25.4905 33.0588 25.5161 33.0917C25.6332 33.2526 25.7575 33.4099 25.8856 33.5672C25.966 33.6733 26.0538 33.7793 26.1379 33.8817C26.3464 34.1305 26.5659 34.3792 26.7927 34.6279C27.2462 35.1254 27.7364 35.6009 28.2521 36.0398C29.2909 36.9396 30.4869 37.6419 31.6903 38.1978C32.1073 38.388 32.5316 38.5636 32.9559 38.7209C33.6838 38.9952 34.419 39.2257 35.1615 39.4232C35.1652 39.4268 35.1652 39.4268 35.1688 39.4268C35.9918 39.6463 36.8221 39.8255 37.6561 39.9645Z"
                    fill="url(#paint10_linear)"
                  />
                  <path
                    d="M37.6556 24.5657V38.1431C35.8962 37.6822 34.1918 37.086 32.6299 36.2777C31.5802 35.7217 30.6218 35.0852 29.7842 34.3062C29.3599 33.9111 28.9612 33.4941 28.5845 33.0479C28.3943 32.8248 28.2114 32.5907 28.0212 32.3529C27.842 32.1225 27.6664 31.8884 27.4982 31.647C27.4579 31.5921 27.4213 31.5373 27.3848 31.4824C27.4433 31.4385 27.4982 31.3946 27.5567 31.3544C27.6518 31.2812 27.7432 31.2081 27.842 31.1349C27.8493 31.1313 27.853 31.1239 27.8603 31.1203C28.5699 30.5826 29.2173 30.0925 29.8098 29.6426C30.1719 29.3719 30.5084 29.1195 30.8303 28.8781C30.8303 28.8781 30.8303 28.8781 30.834 28.8745C30.8706 28.8489 30.9071 28.8196 30.9401 28.794L30.9437 28.7903C30.9474 28.7903 30.951 28.7867 30.951 28.7867C31.624 28.2819 32.2129 27.8466 32.747 27.4662C33.7784 26.7274 34.5904 26.186 35.3476 25.7544C35.7536 25.5203 36.1633 25.3009 36.5656 25.096C36.7668 24.9936 36.968 24.8949 37.1691 24.7961C37.3337 24.7156 37.4947 24.6388 37.6556 24.5657Z"
                    fill="url(#paint11_linear)"
                  />
                  <path
                    d="M37.6597 40.4144V50.3012C37.6597 51.3582 37.4659 52.3751 37.1074 53.3078C37.0452 53.476 36.9757 53.6443 36.8989 53.8089C36.7892 54.0576 36.6648 54.299 36.5295 54.5331C36.4271 54.7087 36.321 54.8843 36.2039 55.0525C34.675 57.313 32.0854 58.8017 29.1555 58.8017C26.8036 58.8017 24.6858 57.8433 23.1496 56.3108C21.6133 54.7672 20.655 52.6384 20.655 50.3012V38.666C20.816 38.5599 20.9769 38.4502 21.1342 38.3404C22.6521 37.2687 23.9799 35.9373 24.9419 34.3865C25.282 34.1085 25.5966 33.8342 25.8856 33.5671C25.966 33.6732 26.0538 33.7793 26.1379 33.8817C26.3464 34.1304 26.5659 34.3792 26.7927 34.6279C27.2462 35.1253 27.7364 35.6008 28.2521 36.0397C29.2909 36.9395 30.4869 37.6418 31.6903 38.1978C32.1073 38.388 32.5316 38.5636 32.9559 38.7209C33.6838 38.9952 34.419 39.2256 35.1615 39.4231C35.1652 39.4268 35.1652 39.4268 35.1688 39.4268C36.0979 39.8547 36.9465 40.173 37.6561 40.4144H37.6597Z"
                    fill="url(#paint12_linear)"
                  />
                  <path
                    d="M34.9973 17.2941C35.0046 17.5831 34.9863 17.872 34.9826 18.161C34.9716 18.4499 34.9753 18.7389 34.9534 19.0242L34.8436 19.8838C34.7851 20.4251 34.6937 20.9591 34.5693 21.4858C34.551 21.5663 34.5327 21.6468 34.5144 21.7236C34.3901 22.232 34.2401 22.7295 34.0792 23.2233C33.3769 25.2716 32.3052 27.1626 30.9518 28.7866C30.9518 28.7866 30.9482 28.7903 30.9445 28.7903L30.9409 28.7939C30.8714 28.8817 30.8019 28.9622 30.7287 29.0463C30.7616 28.9915 30.7982 28.9366 30.8311 28.8781C30.8311 28.8781 30.8311 28.8781 30.8348 28.8744C31.9467 27.0273 32.7843 25.0411 33.2306 22.9855C33.322 22.5685 33.4025 22.1479 33.4683 21.7236C33.4793 21.6468 33.4903 21.5663 33.5012 21.4858C33.5781 20.9189 33.6256 20.3519 33.6256 19.7813L33.6476 18.9803L33.6037 18.1793C33.6037 18.161 33.6037 18.1464 33.6 18.1281C33.589 17.8793 33.5817 17.6306 33.5561 17.3819L33.4427 16.5918C33.3001 15.5384 33.0111 14.5142 32.6856 13.5084C32.3125 12.5171 31.9284 11.5296 31.409 10.6042C30.6336 9.12644 29.6643 7.7292 28.5707 6.47826C25.8896 9.89456 24.0863 14.0534 23.7132 18.3146C23.673 18.6072 23.6693 18.8998 23.6657 19.1961L23.6401 20.074C23.6437 20.5458 23.6803 21.0177 23.7022 21.4858C23.7096 21.5663 23.7132 21.6431 23.7169 21.7236C23.7169 21.7602 23.7205 21.7967 23.7205 21.8333C23.8376 22.9928 24.0753 24.145 24.4045 25.2716C24.7337 26.4018 25.169 27.5101 25.6957 28.5745C25.8713 28.9329 26.0578 29.2914 26.2517 29.6425C26.4163 29.9425 26.5882 30.2387 26.7674 30.5314C26.5187 30.257 26.2663 29.9607 26.0139 29.6425C24.8471 28.1794 23.6876 26.2665 22.967 23.878C22.7549 23.1684 22.5866 22.4515 22.4733 21.7236C22.455 21.6468 22.444 21.5663 22.433 21.4858C21.5186 15.3994 23.8705 8.83383 28.6877 3.83374C28.9437 4.07881 33.194 8.2998 34.6973 14.4484C34.818 15.1031 34.9058 15.7615 34.9424 16.4272L34.9936 17.2648L34.9973 17.2941Z"
                    fill="white"
                  />
                  <path
                    d="M20.6557 36.497C20.7032 36.4677 20.7508 36.4421 20.7947 36.4165C20.7508 36.4458 20.7032 36.4714 20.6557 36.5006C20.6301 36.5153 20.6008 36.5336 20.5752 36.5482C20.6008 36.5299 20.6301 36.5116 20.6557 36.497Z"
                    fill="white"
                  />
                  <path
                    d="M20.8628 36.3726C21.0567 36.2556 21.2395 36.1459 21.4114 36.0361C21.2359 36.1495 21.0567 36.2593 20.8628 36.3726Z"
                    fill="white"
                  />
                  <path
                    d="M34.979 21.4858C34.968 21.5663 34.9534 21.6468 34.9387 21.7236C34.8802 22.0345 34.8144 22.3454 34.7376 22.66C34.3645 24.1816 33.8122 25.5313 33.1794 26.7054C33.1099 26.8371 33.0404 26.9614 32.9709 27.0894C32.9709 27.0894 32.9672 27.0894 32.9672 27.0931C32.8941 27.2211 32.8209 27.3455 32.7478 27.4662C32.254 28.2855 31.7309 29.0134 31.2152 29.6425C31.0579 29.8327 30.9043 30.0156 30.747 30.1875L30.7433 30.1912C29.9204 31.1312 29.1522 31.8189 28.6146 32.2688C28.6036 32.2761 28.5926 32.287 28.5816 32.2944C28.5743 32.287 28.5633 32.2797 28.556 32.2724C28.3731 32.1151 28.1756 31.9396 27.9671 31.7457C27.9306 31.7128 27.894 31.6799 27.8574 31.6433C27.7586 31.5518 27.6599 31.4568 27.5575 31.3543C27.3051 31.1056 27.0417 30.8349 26.7711 30.5387C26.7711 30.535 26.7674 30.5314 26.7674 30.5314C26.5187 30.257 26.2663 29.9607 26.0139 29.6425C24.8471 28.1794 23.6876 26.2665 22.967 23.878C22.7549 23.1684 22.5866 22.4515 22.4733 21.7236C22.455 21.6468 22.444 21.5663 22.433 21.4858C21.5186 15.3994 23.8705 8.83383 28.6877 3.83374C28.9437 4.07881 33.194 8.2998 34.6973 14.4484C34.9095 15.3226 35.0667 16.2334 35.1509 17.1807C35.2716 18.5524 35.235 19.9935 34.979 21.4858Z"
                    fill="url(#paint13_radial)"
                  />
                  <path
                    d="M28.6318 8.72046C29.0232 9.93848 29.2902 11.1967 29.4731 12.4623C29.667 13.7279 29.7584 15.0081 29.7877 16.2919C29.8023 17.5721 29.7584 18.856 29.6084 20.1288C29.4658 21.4017 29.2427 22.6636 28.8952 23.8963L29.0196 20.0886C29.0452 18.8267 29.0598 17.5648 29.0305 16.3029C29.0159 15.041 28.9574 13.7827 28.8842 12.5208L28.6318 8.72046Z"
                    fill="#00CE53"
                  />
                  <path
                    d="M28.083 32.2942C27.7136 30.6958 27.3076 27.7806 28.4634 24.6093C30.2776 19.6275 35.1899 16.0905 41.1373 15.2419C41.1995 15.615 42.5346 24.3643 36.2726 29.3863C33.1087 31.9247 29.5753 32.2466 28.083 32.2942Z"
                    fill="url(#paint14_radial)"
                  />
                  <path
                    d="M27.8501 31.6507C28.6109 31.0618 30.063 30.1254 32.0345 29.9608C35.1326 29.7011 38.2234 31.4422 40.14 34.4013C39.9571 34.5256 35.63 37.3896 31.4164 35.2937C29.2839 34.233 28.2415 32.4334 27.8501 31.6507Z"
                    fill="url(#paint15_radial)"
                  />
                  <path
                    d="M39.5792 17.3928C39.1988 19.4814 38.2916 21.4785 37.048 23.2196C36.4189 24.0864 35.7093 24.8948 34.9119 25.608C34.1219 26.3249 33.255 26.9577 32.3186 27.4625C33.1233 26.7675 33.8914 26.0579 34.612 25.3008C35.3289 24.54 35.9946 23.7426 36.5981 22.8977C37.2126 22.0564 37.754 21.1676 38.2477 20.2495C38.7452 19.3314 39.1768 18.3767 39.5792 17.3928Z"
                    fill="#00CE53"
                  />
                  <path
                    d="M38.9691 34.1343C37.7693 34.3538 36.5221 34.3135 35.3187 34.0831C34.1189 33.8417 32.9485 33.4101 31.9243 32.748C33.0655 33.1723 34.2104 33.5271 35.3845 33.7539C36.5586 33.988 37.7547 34.0904 38.9691 34.1343Z"
                    fill="#00CE53"
                  />
                  <defs>
                    <radialGradient
                      id="paint0_radial"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(29.0589 28.6016) scale(30.6009)"
                    >
                      <stop stop-color="#1D3BCE" />
                      <stop offset="0.0446" stop-color="#1A49D3" />
                      <stop offset="0.1785" stop-color="#126EE0" />
                      <stop offset="0.3188" stop-color="#0B8DEC" />
                      <stop offset="0.465" stop-color="#06A5F4" />
                      <stop offset="0.6199" stop-color="#03B6FA" />
                      <stop offset="0.7892" stop-color="#01C0FE" />
                      <stop offset="1" stop-color="#00C3FF" />
                    </radialGradient>
                    <linearGradient
                      id="paint1_linear"
                      x1="46.3467"
                      y1="23.1876"
                      x2="36.7298"
                      y2="23.028"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#008CFF" />
                      <stop offset="0.191" stop-color="#009FFF" />
                      <stop offset="0.4604" stop-color="#00B3FF" />
                      <stop offset="0.7304" stop-color="#00BFFF" />
                      <stop offset="1" stop-color="#00C3FF" />
                    </linearGradient>
                    <radialGradient
                      id="paint2_radial"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(30.2636 33.9663) scale(6.84866)"
                    >
                      <stop stop-color="#008CFF" />
                      <stop offset="0.191" stop-color="#009FFF" />
                      <stop offset="0.4604" stop-color="#00B3FF" />
                      <stop offset="0.7304" stop-color="#00BFFF" />
                      <stop offset="1" stop-color="#00C3FF" />
                    </radialGradient>
                    <radialGradient
                      id="paint3_radial"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(51.5894 24.6121) scale(19.5884)"
                    >
                      <stop stop-color="#008CFF" />
                      <stop offset="0.191" stop-color="#009FFF" />
                      <stop offset="0.4604" stop-color="#00B3FF" />
                      <stop offset="0.7304" stop-color="#00BFFF" />
                      <stop offset="1" stop-color="#00C3FF" />
                    </radialGradient>
                    <linearGradient
                      id="paint4_linear"
                      x1="-19.4054"
                      y1="27.2565"
                      x2="20.3465"
                      y2="30.7242"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#1D3BCE" />
                      <stop offset="0.0446" stop-color="#1A49D3" />
                      <stop offset="0.1785" stop-color="#126EE0" />
                      <stop offset="0.3188" stop-color="#0B8DEC" />
                      <stop offset="0.465" stop-color="#06A5F4" />
                      <stop offset="0.6199" stop-color="#03B6FA" />
                      <stop offset="0.7892" stop-color="#01C0FE" />
                      <stop offset="1" stop-color="#00C3FF" />
                    </linearGradient>
                    <linearGradient
                      id="paint5_linear"
                      x1="10.4359"
                      y1="24.6765"
                      x2="34.288"
                      y2="26.7572"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#1D3BCE" />
                      <stop offset="0.0446" stop-color="#1A49D3" />
                      <stop offset="0.1785" stop-color="#126EE0" />
                      <stop offset="0.3188" stop-color="#0B8DEC" />
                      <stop offset="0.465" stop-color="#06A5F4" />
                      <stop offset="0.6199" stop-color="#03B6FA" />
                      <stop offset="0.7892" stop-color="#01C0FE" />
                      <stop offset="1" stop-color="#00C3FF" />
                    </linearGradient>
                    <linearGradient
                      id="paint6_linear"
                      x1="15.314"
                      y1="18.4305"
                      x2="15.4856"
                      y2="18.5289"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#1D3BCE" />
                      <stop offset="0.0446" stop-color="#1A49D3" />
                      <stop offset="0.1785" stop-color="#126EE0" />
                      <stop offset="0.3188" stop-color="#0B8DEC" />
                      <stop offset="0.465" stop-color="#06A5F4" />
                      <stop offset="0.6199" stop-color="#03B6FA" />
                      <stop offset="0.7892" stop-color="#01C0FE" />
                      <stop offset="1" stop-color="#00C3FF" />
                    </linearGradient>
                    <linearGradient
                      id="paint7_linear"
                      x1="-127.907"
                      y1="-68.997"
                      x2="-123.016"
                      y2="-66.1915"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#1D3BCE" />
                      <stop offset="0.0446" stop-color="#1A49D3" />
                      <stop offset="0.1785" stop-color="#126EE0" />
                      <stop offset="0.3188" stop-color="#0B8DEC" />
                      <stop offset="0.465" stop-color="#06A5F4" />
                      <stop offset="0.6199" stop-color="#03B6FA" />
                      <stop offset="0.7892" stop-color="#01C0FE" />
                      <stop offset="1" stop-color="#00C3FF" />
                    </linearGradient>
                    <linearGradient
                      id="paint8_linear"
                      x1="19.7686"
                      y1="35.9103"
                      x2="19.7981"
                      y2="35.9272"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#1D3BCE" />
                      <stop offset="0.0446" stop-color="#1A49D3" />
                      <stop offset="0.1785" stop-color="#126EE0" />
                      <stop offset="0.3188" stop-color="#0B8DEC" />
                      <stop offset="0.465" stop-color="#06A5F4" />
                      <stop offset="0.6199" stop-color="#03B6FA" />
                      <stop offset="0.7892" stop-color="#01C0FE" />
                      <stop offset="1" stop-color="#00C3FF" />
                    </linearGradient>
                    <linearGradient
                      id="paint9_linear"
                      x1="17.4796"
                      y1="34.1066"
                      x2="17.5928"
                      y2="34.1716"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#1D3BCE" />
                      <stop offset="0.0446" stop-color="#1A49D3" />
                      <stop offset="0.1785" stop-color="#126EE0" />
                      <stop offset="0.3188" stop-color="#0B8DEC" />
                      <stop offset="0.465" stop-color="#06A5F4" />
                      <stop offset="0.6199" stop-color="#03B6FA" />
                      <stop offset="0.7892" stop-color="#01C0FE" />
                      <stop offset="1" stop-color="#00C3FF" />
                    </linearGradient>
                    <linearGradient
                      id="paint10_linear"
                      x1="-230.517"
                      y1="-101.336"
                      x2="-222.505"
                      y2="-96.7408"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#1D3BCE" />
                      <stop offset="0.0446" stop-color="#1A49D3" />
                      <stop offset="0.1785" stop-color="#126EE0" />
                      <stop offset="0.3188" stop-color="#0B8DEC" />
                      <stop offset="0.465" stop-color="#06A5F4" />
                      <stop offset="0.6199" stop-color="#03B6FA" />
                      <stop offset="0.7892" stop-color="#01C0FE" />
                      <stop offset="1" stop-color="#00C3FF" />
                    </linearGradient>
                    <linearGradient
                      id="paint11_linear"
                      x1="-109.847"
                      y1="-52.7287"
                      x2="-105.36"
                      y2="-50.155"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#1D3BCE" />
                      <stop offset="0.0446" stop-color="#1A49D3" />
                      <stop offset="0.1785" stop-color="#126EE0" />
                      <stop offset="0.3188" stop-color="#0B8DEC" />
                      <stop offset="0.465" stop-color="#06A5F4" />
                      <stop offset="0.6199" stop-color="#03B6FA" />
                      <stop offset="0.7892" stop-color="#01C0FE" />
                      <stop offset="1" stop-color="#00C3FF" />
                    </linearGradient>
                    <linearGradient
                      id="paint12_linear"
                      x1="27.6055"
                      y1="19.4137"
                      x2="29.9778"
                      y2="59.2686"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#1D3BCE" />
                      <stop offset="0.0446" stop-color="#1A49D3" />
                      <stop offset="0.1785" stop-color="#126EE0" />
                      <stop offset="0.3188" stop-color="#0B8DEC" />
                      <stop offset="0.465" stop-color="#06A5F4" />
                      <stop offset="0.6199" stop-color="#03B6FA" />
                      <stop offset="0.7892" stop-color="#01C0FE" />
                      <stop offset="1" stop-color="#00C3FF" />
                    </linearGradient>
                    <radialGradient
                      id="paint13_radial"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(27.9274 31.931) scale(41.2331)"
                    >
                      <stop stop-color="#008CFF" />
                      <stop offset="0.0449" stop-color="#0096EB" />
                      <stop offset="0.3735" stop-color="#00DE5A" />
                      <stop offset="0.5168" stop-color="#00FB20" />
                      <stop offset="0.5479" stop-color="#00FF18" />
                    </radialGradient>
                    <radialGradient
                      id="paint14_radial"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(29.7188 30.5464) rotate(37.2137) scale(31.9077)"
                    >
                      <stop stop-color="#008CFF" />
                      <stop offset="0.0327" stop-color="#009EDB" />
                      <stop offset="0.0845" stop-color="#00B7A8" />
                      <stop offset="0.1375" stop-color="#00CD7C" />
                      <stop offset="0.1905" stop-color="#00DF58" />
                      <stop offset="0.2436" stop-color="#00ED3D" />
                      <stop offset="0.2969" stop-color="#00F729" />
                      <stop offset="0.3505" stop-color="#00FD1D" />
                      <stop offset="0.405" stop-color="#00FF19" />
                      <stop offset="0.577" stop-color="#00FF18" />
                    </radialGradient>
                    <radialGradient
                      id="paint15_radial"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(29.1574 32.0676) rotate(102.392) scale(18.7083)"
                    >
                      <stop stop-color="#008CFF" />
                      <stop offset="0.0412" stop-color="#00A3D1" />
                      <stop offset="0.0873" stop-color="#00B8A6" />
                      <stop offset="0.137" stop-color="#00CB80" />
                      <stop offset="0.1898" stop-color="#00DB60" />
                      <stop offset="0.2464" stop-color="#00E845" />
                      <stop offset="0.3085" stop-color="#00F231" />
                      <stop offset="0.3788" stop-color="#00FA23" />
                      <stop offset="0.4641" stop-color="#00FE1B" />
                      <stop offset="0.607" stop-color="#00FF18" />
                    </radialGradient>
                  </defs>
                </svg>
                {/* <p style={{ color: "rgba(255, 255, 255, 1)" }} className="text-3xl font-semibold ml-8 pt-16">LOGO</p> */}
              </div>
            </div>
            <div
              onClick={() => {
                if (localStorage.access && localStorage.refresh) {
                  history.push("/patientprofile", { user: patient });
                } else {
                  history.push("/login");
                  message.warning("Please login");
                }
              }}
              className="flex mb-4 mt-4 ml-1"
              style={{ alignItems: "center" }}
            >
              <p className="mt-3.5">
                <svg
                  width="16"
                  height="20"
                  viewBox="0 0 16 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M13.294 5.29105C13.294 8.22808 10.9391 10.5831 8 10.5831C5.0619 10.5831 2.70601 8.22808 2.70601 5.29105C2.70601 2.35402 5.0619 0 8 0C10.9391 0 13.294 2.35402 13.294 5.29105ZM8 20C3.66237 20 0 19.295 0 16.575C0 13.8539 3.68538 13.1739 8 13.1739C12.3386 13.1739 16 13.8789 16 16.599C16 19.32 12.3146 20 8 20Z"
                    fill={
                      store.color === Colors.allopathic
                        ? HexColors.allopathic
                        : store.color === Colors.homeopathic
                        ? HexColors.homeopathic
                        : HexColors.ayurvedic
                    }
                  />
                </svg>
              </p>
              <p
                style={{ marginLeft: "20px" }}
                className="pt-3 cursor-pointer ml-3"
                onClick={() => {
                  onClose();
                }}
              >
                My Profile
              </p>
            </div>
            <div
              onClick={() => {
                if (localStorage.access && localStorage.refresh) {
                  history.push("/community", { user: patient });
                } else {
                  history.push("/login");
                  message.warning("Please login");
                }
              }}
              className="flex mb-4 ml-1"
              style={{ alignItems: "center" }}
            >
              <p className="mt-3.5">
                <svg
                  width="22"
                  height="16"
                  viewBox="0 0 22 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M15.1583 4.23285C15.1583 6.58254 13.2851 8.4666 10.949 8.4666C8.61292 8.4666 6.73974 6.58254 6.73974 4.23285C6.73974 1.88227 8.61292 0 10.949 0C13.2851 0 15.1583 1.88227 15.1583 4.23285ZM10.949 16C7.51785 16 4.58809 15.456 4.58809 13.2802C4.58809 11.1034 7.49904 10.5396 10.949 10.5396C14.3802 10.5396 17.31 11.0836 17.31 13.2604C17.31 15.4362 14.399 16 10.949 16ZM16.9571 4.30922C16.9571 5.50703 16.5998 6.62288 15.973 7.55051C15.9086 7.64597 15.9659 7.77476 16.0796 7.79457C16.2363 7.82159 16.3984 7.8369 16.5631 7.8414C18.2062 7.88463 19.6809 6.82102 20.0883 5.21974C20.6918 2.84123 18.9198 0.705896 16.6634 0.705896C16.4181 0.705896 16.1835 0.732013 15.9551 0.778845C15.9238 0.78605 15.8907 0.800459 15.8728 0.828378C15.8513 0.862601 15.8674 0.908532 15.8889 0.938252C16.5667 1.8938 16.9571 3.05918 16.9571 4.30922ZM19.6782 9.51257C20.7823 9.72962 21.5084 10.1727 21.8093 10.8166C22.0636 11.3453 22.0636 11.9586 21.8093 12.4864C21.349 13.4851 19.8654 13.8058 19.2887 13.8886C19.1696 13.9066 19.0738 13.8031 19.0864 13.6833C19.3809 10.9157 17.0377 9.60353 16.4315 9.30183C16.4055 9.28832 16.4002 9.2676 16.4028 9.255C16.4046 9.24599 16.4154 9.23158 16.4351 9.22888C17.7468 9.20456 19.1571 9.38468 19.6782 9.51257ZM5.43711 7.84131C5.60186 7.83681 5.76304 7.8224 5.92063 7.79448C6.03434 7.77467 6.09165 7.64588 6.02718 7.55042C5.4004 6.62279 5.04313 5.50694 5.04313 4.30913C5.04313 3.05909 5.43353 1.89371 6.11135 0.938162C6.13284 0.908442 6.14806 0.862511 6.12746 0.828288C6.10956 0.80127 6.07553 0.78596 6.04509 0.778755C5.81586 0.731923 5.58127 0.705806 5.33593 0.705806C3.07951 0.705806 1.30751 2.84114 1.91191 5.21965C2.31932 6.82093 3.79405 7.88454 5.43711 7.84131ZM5.59694 9.25446C5.59962 9.26796 5.59425 9.28778 5.56918 9.30219C4.9621 9.60389 2.61883 10.9161 2.91342 13.6827C2.92595 13.8034 2.83104 13.9061 2.71195 13.889C2.13531 13.8061 0.651629 13.4855 0.191392 12.4867C-0.0637974 11.9581 -0.0637974 11.3457 0.191392 10.817C0.492248 10.1731 1.21752 9.72998 2.32156 9.51203C2.84358 9.38504 4.25294 9.20492 5.5656 9.22924C5.5853 9.23194 5.59515 9.24635 5.59694 9.25446Z"
                    fill={
                      store.color === Colors.allopathic
                        ? HexColors.allopathic
                        : store.color === Colors.homeopathic
                        ? HexColors.homeopathic
                        : HexColors.ayurvedic
                    }
                  />
                </svg>
              </p>
              <p
                style={{ marginLeft: "15px" }}
                className="pt-3 cursor-pointer ml-3"
              >
                Community
              </p>
            </div>
            <div
              onClick={() => {
                if (localStorage.access && localStorage.refresh) {
                  history.push("/prescription", { user: patient });
                } else {
                  history.push("/login");
                  message.warning("Please login");
                }
              }}
              className="flex mb-4 ml-1"
              style={{ alignItems: "center" }}
            >
              <p className="mt-3.5">
                <svg
                  width="18"
                  height="20"
                  viewBox="0 0 18 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M9.54951 11.73H11.2624C11.6683 11.73 12.005 11.4 12.005 10.99C12.005 10.57 11.6683 10.24 11.2624 10.24H9.54951V8.51C9.54951 8.1 9.22277 7.77 8.81683 7.77C8.41089 7.77 8.07426 8.1 8.07426 8.51V10.24H6.37129C5.96535 10.24 5.62871 10.57 5.62871 10.99C5.62871 11.4 5.96535 11.73 6.37129 11.73H8.07426V13.46C8.07426 13.87 8.41089 14.2 8.81683 14.2C9.22277 14.2 9.54951 13.87 9.54951 13.46V11.73ZM16.3381 7.02561C16.5708 7.02292 16.8242 7.02 17.0545 7.02C17.302 7.02 17.5 7.22 17.5 7.47V15.51C17.5 17.99 15.5099 20 13.0446 20H5.17327C2.59901 20 0.5 17.89 0.5 15.29V4.51C0.5 2.03 2.5 0 4.96535 0H10.2525C10.5099 0 10.7079 0.21 10.7079 0.46V3.68C10.7079 5.51 12.203 7.01 14.0149 7.02C14.4381 7.02 14.8112 7.02316 15.1377 7.02593C15.3917 7.02809 15.6175 7.03 15.8168 7.03C15.9578 7.03 16.1405 7.02789 16.3381 7.02561ZM16.61 5.5662C15.7961 5.5692 14.8367 5.5662 14.1466 5.5592C13.0516 5.5592 12.1496 4.6482 12.1496 3.5422V0.9062C12.1496 0.4752 12.6674 0.2612 12.9635 0.5722C13.4995 1.1351 14.2361 1.90891 14.9693 2.67913C15.7002 3.44689 16.4277 4.21108 16.9496 4.7592C17.2387 5.0622 17.0268 5.5652 16.61 5.5662Z"
                    fill={
                      store.color === Colors.allopathic
                        ? HexColors.allopathic
                        : store.color === Colors.homeopathic
                        ? HexColors.homeopathic
                        : HexColors.ayurvedic
                    }
                  />
                </svg>
              </p>
              <p
                style={{ marginLeft: "20px" }}
                className="pt-3 cursor-pointer ml-3"
              >
                My Prescription
              </p>
            </div>
            <div
              onClick={() => {
                if (localStorage.access && localStorage.refresh) {
                  history.push("/myupload", { user: patient });
                } else {
                  history.push("/login");
                  message.warning("Please login");
                }
              }}
              className="flex mb-4 ml-1"
              style={{ alignItems: "center" }}
            >
              <p className="mt-2">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9.2301 5.29052V1.2815C9.2301 0.855229 9.5701 0.5 10.0001 0.5C10.3851 0.5 10.7113 0.798491 10.763 1.17658L10.7701 1.2815V5.29052L15.55 5.29083C17.93 5.29083 19.8853 7.23978 19.9951 9.67041L20 9.88609V14.9254C20 17.373 18.1127 19.3822 15.768 19.495L15.56 19.5H4.44C2.06 19.5 0.11409 17.5608 0.00483778 15.1213L0 14.9047L0 9.87576C0 7.4281 1.87791 5.40921 4.22199 5.29585L4.43 5.29083H9.23V11.6932L7.63 10.041C7.33 9.73119 6.84 9.73119 6.54 10.041C6.39 10.1959 6.32 10.4024 6.32 10.6089C6.32 10.7659 6.3648 10.9295 6.45952 11.0679L6.54 11.1666L9.45 14.1819C9.59 14.3368 9.79 14.4194 10 14.4194C10.1667 14.4194 10.3333 14.362 10.4653 14.2533L10.54 14.1819L13.45 11.1666C13.75 10.8568 13.75 10.3508 13.45 10.041C13.1773 9.75936 12.7475 9.73375 12.4462 9.96418L12.36 10.041L10.77 11.6932V5.29083L9.2301 5.29052Z"
                    fill={
                      store.color === Colors.allopathic
                        ? HexColors.allopathic
                        : store.color === Colors.homeopathic
                        ? HexColors.homeopathic
                        : HexColors.ayurvedic
                    }
                  />
                </svg>
              </p>
              <p
                style={{ marginLeft: "20px" }}
                className="pt-3 cursor-pointer ml-3"
              >
                My Uploads
              </p>
            </div>
            <div className="flex mb-4 ml-1" style={{ alignItems: "center" }}>
              <p className="mt-3.5">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M11.8204 20H8.18037C7.9523 20 7.73107 19.9221 7.55337 19.7792C7.37567 19.6362 7.25218 19.4368 7.20337 19.214L6.79637 17.33C6.25343 17.0921 5.73861 16.7946 5.26137 16.443L3.42437 17.028C3.20694 17.0973 2.97232 17.0902 2.75949 17.0078C2.54666 16.9254 2.36842 16.7727 2.25437 16.575L0.430373 13.424C0.317518 13.2261 0.275155 12.9958 0.310215 12.7708C0.345275 12.5457 0.455682 12.3392 0.623373 12.185L2.04837 10.885C1.98357 10.2961 1.98357 9.70189 2.04837 9.113L0.623373 7.816C0.455444 7.66177 0.344887 7.45507 0.309822 7.22978C0.274756 7.00449 0.317262 6.77397 0.430373 6.576L2.25037 3.423C2.36442 3.22532 2.54266 3.07259 2.75549 2.99019C2.96832 2.90778 3.20294 2.90066 3.42037 2.97L5.25737 3.555C5.50137 3.375 5.75537 3.207 6.01737 3.055C6.27037 2.913 6.53037 2.784 6.79637 2.669L7.20437 0.787C7.25294 0.564198 7.3762 0.364688 7.55372 0.221549C7.73123 0.0784098 7.95234 0.000239966 8.18037 0H11.8204C12.0484 0.000239966 12.2695 0.0784098 12.447 0.221549C12.6245 0.364688 12.7478 0.564198 12.7964 0.787L13.2084 2.67C13.4884 2.794 13.7624 2.933 14.0274 3.088C14.2744 3.231 14.5134 3.388 14.7434 3.557L16.5814 2.972C16.7987 2.90292 17.0331 2.91017 17.2457 2.99256C17.4583 3.07495 17.6364 3.22753 17.7504 3.425L19.5704 6.578C19.8024 6.985 19.7224 7.5 19.3774 7.817L17.9524 9.117C18.0172 9.70589 18.0172 10.3001 17.9524 10.889L19.3774 12.189C19.7224 12.507 19.8024 13.021 19.5704 13.428L17.7504 16.581C17.6363 16.7787 17.4581 16.9314 17.2453 17.0138C17.0324 17.0962 16.7978 17.1033 16.5804 17.034L14.7434 16.449C14.2665 16.8003 13.752 17.0975 13.2094 17.335L12.7964 19.214C12.7476 19.4366 12.6243 19.6359 12.4468 19.7788C12.2693 19.9218 12.0483 19.9998 11.8204 20ZM9.99637 6C8.93551 6 7.91809 6.42143 7.16795 7.17157C6.4178 7.92172 5.99637 8.93913 5.99637 10C5.99637 11.0609 6.4178 12.0783 7.16795 12.8284C7.91809 13.5786 8.93551 14 9.99637 14C11.0572 14 12.0747 13.5786 12.8248 12.8284C13.5749 12.0783 13.9964 11.0609 13.9964 10C13.9964 8.93913 13.5749 7.92172 12.8248 7.17157C12.0747 6.42143 11.0572 6 9.99637 6Z"
                    fill={
                      store.color === Colors.allopathic
                        ? HexColors.allopathic
                        : store.color === Colors.homeopathic
                        ? HexColors.homeopathic
                        : HexColors.ayurvedic
                    }
                  />
                </svg>
              </p>
              <p
                style={{ marginLeft: "20px" }}
                className="pt-3 cursor-pointer ml-3"
              >
                Settings
              </p>
            </div>
            <div className="flex mb-7 ml-1" style={{ alignItems: "center" }}>
              <p className="mt-3.5">
                <svg
                  style={{ marginLeft: "-5px" }}
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M16 13V11H7V8L2 12L7 16V13H16Z"
                    fill={
                      store.color === Colors.allopathic
                        ? HexColors.allopathic
                        : store.color === Colors.homeopathic
                        ? HexColors.homeopathic
                        : HexColors.ayurvedic
                    }
                  />
                  <path
                    d="M20 3H11C9.897 3 9 3.897 9 5V9H11V5H20V19H11V15H9V19C9 20.103 9.897 21 11 21H20C21.103 21 22 20.103 22 19V5C22 3.897 21.103 3 20 3Z"
                    fill={
                      store.color === Colors.allopathic
                        ? HexColors.allopathic
                        : store.color === Colors.homeopathic
                        ? HexColors.homeopathic
                        : HexColors.ayurvedic
                    }
                  />
                </svg>
              </p>
              <Popconfirm
                title="You will be loggedd out!!"
                icon={<QuestionCircleOutlined style={{ color: "red" }} />}
                onConfirm={confirm}
                onCancel={cancel}
                okText="Confirm"
                cancelText="Cancel"
              >
                <p
                  style={{ marginLeft: "20px" }}
                  className="pt-3 cursor-pointer ml-3"
                >
                  Log Out
                </p>
              </Popconfirm>
            </div>

            <div>
              <div
                style={{
                  color: "rgba(159, 159, 159, 1)",
                  marginBottom: "2.5rem",
                }}
              >
                Type of medicine
                <span>
                  <hr
                    style={{ border: "0.1px solid rgba(222, 222, 222, 1)" }}
                    className="w-20 ml-32 -mt-3"
                  ></hr>
                </span>
              </div>
              <div
                className=" cursor-pointer "
                onClick={() => {
                  store.updateColor(Colors.allopathic);
                  localStorage.setItem("Specialization", 3);
                }}
              >
                <p
                  className="mt-3 pl-2 py-3  "
                  style={{
                    border:
                      store.color === Colors.allopathic
                        ? `0.1px solid ${HexColors.allopathic}`
                        : "0.1px solid transparent",
                    borderRadius: "10px",
                  }}
                >
                  Allopathic
                </p>

                <p
                  style={{
                    marginTop: "-29px",
                    marginLeft: "184px",
                    visibility:
                      store.color === Colors.allopathic ? "visible" : " hidden",
                  }}
                >
                  {" "}
                  <svg
                    width="17"
                    height="13"
                    viewBox="0 0 17 13"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M2 6.51955L6.52145 11.0391L15.5605 2"
                      stroke={HexColors.allopathic}
                      stroke-width="2.86"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>{" "}
                </p>
              </div>
              <div
                className=" "
                onClick={() => {
                  store.updateColor(Colors.homeopathic);
                  localStorage.setItem("Specialization", "2");
                }}
              >
                <p
                  className=" mt-3  pl-2 py-3"
                  style={{
                    border:
                      store.color === Colors.homeopathic
                        ? `0.1px solid ${HexColors.homeopathic}`
                        : "0.1px solid transparent",
                    borderRadius: "10px",
                  }}
                >
                  Homeopathic
                </p>

                <p
                  style={{
                    marginTop: "-29px",
                    marginLeft: "184px",
                    visibility:
                      store.color === Colors.homeopathic ? "visible" : "hidden",
                  }}
                >
                  <svg
                    width="17"
                    height="13"
                    viewBox="0 0 17 13"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M2 6.51955L6.52145 11.0391L15.5605 2"
                      stroke={HexColors.homeopathic}
                      stroke-width="2.86"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </p>
              </div>
              <div
                className="  "
                onClick={() => {
                  store.updateColor(Colors.ayurvedic);
                  localStorage.setItem("Specialization", "1");
                }}
              >
                <p
                  className=" mt-3   pl-2 py-3"
                  style={{
                    border:
                      store.color === Colors.ayurvedic
                        ? `0.1px solid ${HexColors.ayurvedic}`
                        : "0.1px solid transparent",
                    borderRadius: "10px",
                  }}
                >
                  Ayurvedic
                </p>

                <p
                  style={{
                    marginTop: "-29px",
                    marginLeft: "184px",
                    visibility:
                      store.color === Colors.ayurvedic ? "visible" : "hidden",
                  }}
                >
                  <svg
                    width="17"
                    height="13"
                    viewBox="0 0 17 13"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M2 6.51955L6.52145 11.0391L15.5605 2"
                      stroke={HexColors.ayurvedic}
                      stroke-width="2.86"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </p>
              </div>
            </div>
            <p
              className="fixed xl:hidden block md:static bottom-8 left-28 w-full mt-2 text-sm "
              style={{ color: "#9F9F9F" }}
            >
              V1.5689
            </p>
          </Drawer>
        </div>
        <div
          onClick={() => {
            history.push("/patientprofile");
          }}
          className="flex mt-2 cursor-pointer"
          style={{
            alignItems: "center",
            boxShadow: "0px 0px 9px rgba(0, 0, 0, 0.1)",
            borderRadius: "24px",
          }}
        >
          <div
            style={{ minWidth: "80px", width: "70px" }}
            className="mr-2 bottom-2 pl-2 truncate"
          >
            {localStorage.access && localStorage.refresh
              ? patient
                ? patient.name
                : "Hello"
              : "Guest"}
          </div>
          {/* <img className="inline-block h-8 w-8 rounded-full ring-2 ring-white" src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80" alt="" /> */}
          {patient.profile_pic ? (
            <Avatar
              className="inline-block rounded-full ring-2 ring-white"
              style={{ height: "2rem", width: "2rem" }}
              src={patient.profile_pic}
              // icon={patient.profile_pic ? patient.profile_pic : <UserOutlined />}
            />
          ) : (
            <Avatar
              className="inline-block rounded-full ring-2 ring-white"
              style={{ height: "2rem", width: "2rem" }}
              // src={patient.profile_pic}
              icon={<UserOutlined />}
            />
          )}
        </div>
      </div>
    );
  })
);

export default Header;
